module.exports = __webpack_public_path__ + "img/leeside_screen.200cbd8b.png";